import Vue from 'vue'
import VueRouter from 'vue-router'
// import Index from '@/components/Index'
import FT_Invest from '@/components/FT_Invest'
import SS_Invest from '@/components/SS_Invest'
// import Start from '@/components/StartEnlighting_new'
import Target from '@/components/Target'
// import AudioTemplate from '@/components/resource/Audio'
import AudioTemplateNew from '@/components/resource/AudioNew'
import BookTemplateNew from '@/components/resource/BookNew'
import VideoTemplate from '@/components/resource/Video'
import ActivityTemplate from '@/components/resource/Activity'
import WordTemplate from '@/components/resource/WordNew'
import SentenceTemplate from '@/components/resource/Sentence'
import ParentArticleTemplate from '@/components/resource/ParentArticle'
import GrammarTemplate from '@/components/resource/Grammar'
import PhonicTemplate from '@/components/resource/Phonic'
import Feedback from '@/components/Feedback'
// import CejTarget from '@/components/template/target/CejTarget'
import PeasonalizedTarget from '@/components/template/target/PeasonalizedTarget'
import KnowleagePointsReview from '@/components/template/target/KnowleagePointsReview'
import UnitKnowledgeTemplate from '@/components/template/target/UnitKnowledgeMastery'
import UnitKnowleageReview from '@/components/template/target/UnitKnowleageReview'
import WeakKnowledgeREview from '@/components/template/target/WeakKnowledgeREview'
import LevelPlan from '@/components/parentread/LevelPlan'
import FirstMonth from '@/components/parentread/FirstMonth'
import WordUnitTemplate from '@/components/resource/WordUnit'

import ParentRead1 from '@/components/parentread/UnderstandValid1'
import ParentRead2 from '@/components/parentread/PictureBook2'
import ParentRead3 from '@/components/parentread/KeyPeroid3'
import FeedbackFlm from '@/components/FeedbackFiveLittleMonkeys'
import WordUnitTemplateV2 from '@/components/resource/WordUnitV2'
import suyangWordUnitTemplateV2 from '@/components/resource/suyangWordUnitV2'
import WordTemplateV2 from '@/components/resource/WordV2'
// file name must be upletter

Vue.use(VueRouter)

let routes = [
  // {
  //   path: '/',
  //   name: 'Index',
  //   component: Index,
  //   meta: {
  //     title: '51英文启蒙产品'
  //   }
  // },
  {
    path: '/ft_invest',
    name: 'FT_Invest',
    component: FT_Invest,
    meta: {
      title: '51Talk体验课调查问卷'
    }
  },
  {
    path: '/user_invest',
    name: 'SS_Invest',
    component: SS_Invest,
    meta: {
      title: '51Talk用户调研系统'
    }
  },
  {
    path: '/peasonalized_target',
    name: 'PeasonalizedTarget',
    component: PeasonalizedTarget,
    meta: {
      title: '个性化学习规划'
    }
  },
  {
    path: '/KnowleagePointsReview',
    name: 'KnowleagePointsReview',
    component: KnowleagePointsReview,
    meta: {
      title: '阶段复习计划'
    }
  },
  {
    path: '/UnitKnowleageReview',
    name: 'UnitKnowleageReview',
    component: UnitKnowleageReview,
    meta: {
      title: '单元知识复习'
    }
  },
  {
    path: '/WeakKnowledgeREview',
    name: 'WeakKnowledgeREview',
    component: WeakKnowledgeREview,
    meta: {
      title: '薄弱知识回顾'
    }
  },
  {
    path: '/target/unitknowledge_mastery',
    name: 'UnitKnowledgeTemplate',
    component: UnitKnowledgeTemplate,
    meta: {
      title: '单元知识点掌握报告'
    }
  },
  // {
  //   path: '/cej_target/:level/:unit/:u_name',
  //   name: 'CejTarget',
  //   component: CejTarget,
  //   meta: {
  //     title: 'CEJ单元目标规划'
  //   }
  // },
  // {
  //   path: '/invest',
  //   name: 'Invest',
  //   component: Invest,
  //   meta: {
  //     title: '启蒙调查'
  //   }
  // },
  // {
  //   path: '/start',
  //   name: 'Start',
  //   component: Start,
  //   meta: {
  //     title: '不可错过的少儿英文启蒙路线'
  //   }
  // },
  {
    path: '/target',
    name: 'Target',
    component: Target,
    meta: {
      title: '目标规划'
    }
  },
  {
    path: '/target/:id',
    name: 'Target',
    component: Target,
    meta: {
      title: '目标规划'
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: {
      title: '内容反馈'
    }
  },
  {
    path: '/feedback/:id',
    name: 'Feedback',
    component: Feedback,
    meta: {
      title: '绘本学习内容反馈'
    }
  },
  {
    path: '/resource/audio/:id',
    name: 'AudioTemplateNew',
    component: AudioTemplateNew,
    meta: {
      title: '儿歌学习'
    }
  },
  {
    path: '/resource/book/:id',
    name: 'BookTemplateNew',
    component: BookTemplateNew,
    meta: {
      title: '绘本阅读'
    }
  },
  {
    path: '/resource/video/:id',
    name: 'VideoTemplate',
    component: VideoTemplate,
    meta: {
      title: '动画视频'
    }
  },
  {
    path: '/resource/parent_article/:id',
    name: 'ParentArticleTemplate',
    component: ParentArticleTemplate,
    meta: {
      title: '家长启蒙学习'
    }
  },
  {
    path: '/resource/activity/:id',
    name: 'ActivityTemplate',
    component: ActivityTemplate,
    meta: {
      title: '单元亲子活动'
    }
  },
  {
    path: '/resource/activity',
    name: 'ActivityTemplate',
    component: ActivityTemplate,
    meta: {
      title: '51talk单元亲子活动'
    }
  },
  {
    path: '/resource/phonic/:id',
    name: 'PhonicTemplate',
    component: PhonicTemplate,
    meta: {
      title: '自然拼读学习'
    }
  },
  {
    path: '/resource/sentence/:id',
    name: 'SentenceTemplate',
    component: SentenceTemplate,
    meta: {
      title: '核心句子学习'
    }
  },
  {
    path: '/resource/grammar/:id',
    name: 'GrammarTemplate',
    component: GrammarTemplate,
    meta: {
      title: '语法知识园地'
    }
  },
  {
    path: '/resource/word/:id',
    name: 'WordTemplate',
    component: WordTemplate,
    meta: {
      title: '51talk单词成人版'
    }
  },
  {
    path: '/resource/word_v2/:id',
    name: 'WordTemplateV2',
    component: WordTemplateV2,
    meta: {
      title: '51talk单词学习页面'
    }
  },
  {
    path: '/resource/wordunit',
    name: 'WordUnitTemplate',
    component: WordUnitTemplate,
    meta: {
      title: '单元重点单词'
    }
  },
  {
    path: '/resource/wordunit_v2',
    name: 'WordUnitTemplateV2',
    component: WordUnitTemplateV2,
    meta: {
      title: '单元重点单词v2'
    }
  },
  {
    path: '/resource/wordunit_v2_suyang',
    name: 'suyangWordUnitTemplateV2',
    component: suyangWordUnitTemplateV2,
    meta: {
      title: '单元重点单词v2'
    }
  },
  {
    path: '/resource/levelplan/:id',
    component: LevelPlan,
    meta: {
      'title': 'CEJ Level学习攻略'
    }
  },
  {
    path: '/resource/firstmonth/:id',
    component: FirstMonth,
    meta: {
      'title': '首月服务助力学习效果'
    }
  }
]

let parentRoute = [{
    path: '/resource/parent/1',
    component: ParentRead1,
    meta: {
      'title': '95%的妈妈都不知道的少儿英语启蒙要点'
    }
  },
  {
    path: '/resource/parent/2',
    component: ParentRead2,
    meta: {
      'title': '父母英语水平差，还可以亲子阅读吗？'
    }
  },
  {
    path: '/resource/parent/3',
    component: ParentRead3,
    meta: {
      'title': '孩子学英语，到底有没有关键期？'
    }
  },
  {
    path: '/feedback_FiveLittleMonkeys',
    // name: 'Feedback_FLM',
    component: FeedbackFlm,
    meta: {
      title: 'Five Little Monkeys反馈'
    }
  }
]

routes = routes.concat(parentRoute)

export default new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js